import { Drawer } from 'antd';
import Sidebar from 'components/UI/layout/components/dashboardSidebar/Sidebar';
import { FC } from 'react';

interface IHeaderDrawer {
  open: boolean;
  close(): void;
}

const HeaderDrawer: FC<IHeaderDrawer> = ({ open, close }) => {
  return (
    <Drawer open={open} onClose={close} width={150}>
      <Sidebar />
    </Drawer>
  );
};

export default HeaderDrawer;
